import React from "react";
import styles from "./CompanyName.module.css";
import { Link } from "react-router-dom";

interface CompanyNameProps {
  isVisible: boolean;
}

const CompanyName: React.FC<CompanyNameProps> = ({ isVisible }) => {
  return (
    <div className={styles.companyNameBox}>
      <Link
        to="/"
        onClick={() => {
          window.scroll(0, 0);
        }}
      >
        <h1
          className={`${styles.companyName} ${
            isVisible ? styles.companyNameVisible : ""
          }`}
        >
          The Hideaway Retreat
        </h1>
      </Link>
    </div>
  );
};

export default CompanyName;
